import { render, staticRenderFns } from "./ProductsInventory.vue?vue&type=template&id=710dec48&"
import script from "./ProductsInventory.vue?vue&type=script&lang=js&"
export * from "./ProductsInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports